import {gql} from "@apollo/client";

const GetDomesticRegionByCountryIdQuery = gql`
    query GetDomesticRegionByCountryIdQuery($countryId: String) {
        domesticRegions(countryId: $countryId) {
            id
            name
            country {
                id
            }
        }
    }
`;

export default GetDomesticRegionByCountryIdQuery;
